import { createRouter, createWebHistory } from "vue-router";
import axios from "axios";

import store from "./store";
import Auth from "./pages/Auth.vue";

import ApproveUsers from "./pages/ApproveUsers.vue";
import TestIts from "./pages/TestIts.vue";
import Tools from "./pages/Tools.vue";
import CarPartGroups from "./pages/CarPartGroups.vue";
import Quality from "./pages/Quality.vue";
import Users from "./pages/Users.vue";
import Institutions from "./pages/Institutions.vue";
import Cars from "./pages/Cars.vue";
import Cities from "./pages/Cities.vue";
import Clients from "./pages/Clients.vue";
import States from "./pages/States.vue";
import Repositories from "./pages/Repositories.vue";
import Shipments from "./pages/Shipments.vue";
import OrderedParts from "./pages/OrderedParts.vue";
import Tests from "./pages/Tests.vue";
import Warranties from "./pages/Warranties.vue";
import Home from "./pages/Home.vue";
import Settings from "./pages/Settings.vue";
import ApproveParts from "./pages/ApproveParts.vue";
import InsertParts from "./pages/InsertParts.vue";
import Inventory from "./pages/Inventory.vue";
import DamagedParts from "./pages/DamagedParts.vue";
import LostParts from "./pages/LostParts.vue";
import RecycledParts from "./pages/RecycledParts.vue";
import Sales from "./pages/Sales.vue";
import Shippings from "./pages/Shippings.vue";
import Movements from "./pages/Movements.vue";
import Reservations from "./pages/Reservations.vue";
import PartRequests from "./pages/PartRequests.vue";
import VehicleEntry from "./pages/VehicleEntry.vue";
import VehicleAcceptance from "./pages/VehicleAcceptance.vue";
import Workshop from "./pages/Workshop.vue";
import WorkshopChecklist from "./pages/WorkshopChecklist.vue";
import WasteContainers from "./pages/WasteContainers.vue";
import WasteContainer from "./pages/WasteContainer.vue";
import CarLocations from "./pages/CarLocations.vue";
import CarVersions from "./pages/CarVersions.vue";
import Introduction from "./pages/Introduction.vue";
import SearchTerms from "./pages/SearchTerms.vue";
import ComplianceDocs from "./pages/ComplianceDocs.vue";
// import Documentation from './pages/Documentation.vue';
import LekoTechAi from "./pages/LekoTechAI.vue";
import PartsWithAi from "./pages/PartsWithAI.vue";
import CommonCodes from "./pages/CommonCodes.vue";
import PriceOneAverages from "./pages/PriceOneAverages.vue";
import OemStockWatchlist from "./pages/OemStockWatchlist.vue";
import EbayShippingPrice from "./pages/EbayShippingPrice.vue";
import InstitutionEbayShippingPrice from "./pages/InstitutionEbayShippingPrice.vue";
import EbayExclusions from "./pages/ebayExclusions.vue";
import ListingRefresh from "./pages/ListingRefresh.vue";
import ListingRefreshInstitution from "./pages/ListingRefreshInstitution.vue";
import GlobalSettings from "./pages/GlobalSettings.vue";
import institutionDetails from "@/components/Institutions/institutionDetails.vue";
import EbayDocumentation from "./pages/EbaySteps.vue";
import EbayInvoicesShippingDocs from "./pages/EbayInvoicesShippingDocs.vue";
import EbayCategories from "./pages/EbayCategories.vue";
import EditEbayCategories from "./pages/AdminEbayCategories.vue";
import InternationalEbayShipping from "./pages/EbayShippingGuide.vue";
import EbayRrShippingDocs from "./pages/EbayRrShippingDocs.vue";
import SupportTicketsDocs from "./pages/SupportTicketsDocs.vue";
import PlateLogs from "./pages/PlateLogs.vue";
import ClonedParts from "./pages/ClonedParts.vue";
import ResetPassword from "./pages/ResetPassword.vue";
import SendResetPassword from "./pages/SendResetPassword.vue";
import VerifyEmail from "./pages/VerifyEmail.vue";
import Terms from "./pages/Terms.vue";
import ReferralProgram from "./pages/ReferralProgram.vue";
import ReteRicambiDisplay from "./pages/ReteRicambiDisplay.vue";
import ShippingBulkImport from "./pages/ShippingBulkImport.vue";
import ReteRicambiUserAccess from "./pages/ReteRicambiUserAccess.vue";
import ReteRicambiPassReset from "./pages/ReteRicambiPassReset.vue";
import ModuliRrOverview from "./pages/ModuliRrOverview.vue";
import ModuliRrOrders from "./pages/ModuliRrOrders.vue";
import ModuliRrSales from "./pages/ModuliRrSales.vue";
import config from "./config";
import { isReteRicambiInternalAdminEmail } from "./constants/reteRicambiInternalAdminAllowlist";

const baseRoutes = [
  {
    path: "/auth",
    name: "auth",
    component: Auth,
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms,
    meta: {
      public: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: {
      name: "inventory",
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/approve-users",
    name: "approve-users",
    component: ApproveUsers,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/car-part-groups",
    name: "car-part-groups",
    component: CarPartGroups,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/shippings",
    name: "shippings",
    component: Shippings,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/test-its",
    name: "test-its",
    component: TestIts,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/tools",
    name: "tools",
    component: Tools,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/part-requests",
    name: "part-requests",
    component: PartRequests,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/quality",
    name: "quality",
    component: Quality,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/sales",
    name: "sales",
    component: Sales,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reservations",
    name: "reservations",
    component: Reservations,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/clients",
    name: "clients",
    component: Clients,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/institutions",
    name: "institutions",
    component: Institutions,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/cars",
    name: "cars",
    component: Cars,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/approve-parts",
    name: "approve-parts",
    component: ApproveParts,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/inventory",
    name: "inventory",
    component: Inventory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/damaged",
    name: "damaged",
    component: DamagedParts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lost",
    name: "lost",
    component: LostParts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/recycled",
    name: "recycled",
    component: RecycledParts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/insert-parts",
    name: "insert-parts",
    component: InsertParts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/movements",
    name: "movements",
    component: Movements,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ordered",
    name: "ordered",
    component: OrderedParts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shipments",
    name: "shipments",
    component: Shipments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/repositories",
    name: "repositories",
    component: Repositories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cities",
    name: "cities",
    component: Cities,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/states",
    name: "states",
    component: States,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/warranties",
    name: "warranties",
    component: Warranties,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/tests",
    name: "tests",
    component: Tests,
    meta: {
      requiresAuth: true,
      employeeRole: true,
    },
  },
  {
    path: "/vehicle-entry",
    name: "vehicle-entry",
    component: VehicleEntry,
    meta: {
      requiresAuth: true,
    },
  },
  {
    // Dismantling & Compliance. Reached from the vehicle list only, so no nav entry.
    path: "/acceptance/:dossierId",
    name: "acceptance",
    component: VehicleAcceptance,
    meta: {
      requiresAuth: true,
      requiresCompliance: true,
    },
  },
  {
    // Workshop depollution checklist (Stage 3a): "Bonifica officina" in the sidebar.
    path: "/workshop",
    name: "workshop",
    component: Workshop,
    meta: {
      requiresAuth: true,
      requiresWorkshop: true,
    },
  },
  {
    path: "/workshop/:checklistId",
    name: "workshop-checklist",
    component: WorkshopChecklist,
    meta: {
      requiresAuth: true,
      requiresWorkshop: true,
    },
  },
  {
    // Waste containers (Stage 6): "Rifiuti e contenitori" in the sidebar.
    path: "/waste",
    name: "waste",
    component: WasteContainers,
    meta: {
      requiresAuth: true,
      requiresWaste: true,
    },
  },
  {
    path: "/waste/containers/:containerId",
    name: "waste-container",
    component: WasteContainer,
    meta: {
      requiresAuth: true,
      requiresWaste: true,
    },
  },
  {
    path: "/car-locations",
    name: "car-locations",
    component: CarLocations,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/car-versions",
    name: "car-versions",
    component: CarVersions,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/documentation',
  //   name: 'documentation',
  //   component: Documentation,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/lekoTechAi",
    name: "lekoTechAi",
    component: LekoTechAi,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/partsWithAI",
    name: "partsWithAI",
    component: PartsWithAi,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/introduction",
    name: "introduction",
    component: Introduction,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/search-terms",
    name: "search-terms",
    component: SearchTerms,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/compliance-docs",
    name: "compliance-docs",
    component: ComplianceDocs,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/institution/:id",
    name: "institutionDetails",
    component: institutionDetails,
    meta: {
      requiresAuth: true,
      // employeeRole: true,
      superAdminRole: true,
    },
    props: true,
  },
  {
    path: "/common-codes",
    name: "common-codes",
    component: CommonCodes,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/price-one-averages",
    name: "price-one-averages",
    component: PriceOneAverages,
    meta: {
      requiresAuth: true,
      allowedRoles: [
        "EbayOperator",
        "InstitutionManager",
        "InstitutionAdmin",
        "LekoAdmin",
        "LekoEmployee",
        "SuperAdmin",
      ],
    },
  },
  {
    path: "/oem-stock-watchlist",
    name: "oem-stock-watchlist",
    component: OemStockWatchlist,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ebay-shipping-price",
    name: "ebay-shipping-price",
    component: EbayShippingPrice,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/institution-ebay-shipping-price",
    name: "institution-ebay-shipping-price",
    component: InstitutionEbayShippingPrice,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ebay-exclusions",
    name: "ebay-exclusions",
    component: EbayExclusions,
    meta: {
      requiresAuth: true,
      allowedRoles: ["SuperAdmin", "InstitutionAdmin"],
      requiresEbayExportLeko: true,
    },
  },
  {
    path: "/listing-refresh",
    name: "listing-refresh",
    component: ListingRefresh,
    meta: {
      requiresAuth: true,
      allowedRoles: ["SuperAdmin"],
    },
  },
  {
    path: "/global-settings",
    name: "global-settings",
    component: GlobalSettings,
    meta: {
      requiresAuth: true,
      allowedRoles: ["SuperAdmin"],
    },
  },
  {
    path: "/maintenance-notice",
    redirect: { name: "global-settings" },
  },
  {
    path: "/listing-refresh/:institutionId",
    name: "listing-refresh-institution",
    component: ListingRefreshInstitution,
    meta: {
      requiresAuth: true,
      allowedRoles: ["SuperAdmin"],
    },
  },
  {
    path: "/shipping-bulk-import",
    name: "shipping-bulk-import",
    component: ShippingBulkImport,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/ebay-documentation",
    name: "ebay-documentation",
    component: EbayDocumentation,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ebay-invoices-shipping-docs",
    name: "ebay-invoices-shipping-docs",
    component: EbayInvoicesShippingDocs,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ebay-categories",
    name: "ebay-categories",
    component: EbayCategories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-ebay-categories",
    name: "edit-ebay-categories",
    component: EditEbayCategories,
    meta: {
      requiresAuth: true,
      adminRole: true,
    },
  },
  {
    path: "/international-ebay-shipping",
    name: "international-ebay-shipping",
    component: InternationalEbayShipping,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ebay-rr-shipping-docs",
    name: "ebay-rr-shipping-docs",
    component: EbayRrShippingDocs,
    meta: {
      requiresAuth: true,
      requiresRrMember: true,
    },
  },
  {
    path: "/support-tickets-docs",
    name: "support-tickets-docs",
    component: SupportTicketsDocs,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/plate-logs",
    name: "plate-logs",
    component: PlateLogs,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloned-parts",
    name: "cloned-parts",
    component: ClonedParts,
    meta: {
      requiresAuth: true,
      superAdminRole: true,
    },
  },
  {
    path: "/reset",
    name: "reset",
    component: SendResetPassword,
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/reset-password",
    name: "reset-pass",
    component: ResetPassword,
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/verify-email",
    name: "verify-email",
    component: VerifyEmail,
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/referral-program",
    name: "referral-program",
    component: ReferralProgram,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rr-display",
    name: "rr-display",
    component: ReteRicambiDisplay,
    meta: {
      requiresAuth: true,
      rrDisplayRole: true,
    },
  },
  {
    path: "/system/maintenance/r9k7-m4pq/user-moderation",
    name: "retericambi-user-moderation",
    component: ReteRicambiUserAccess,
    meta: {
      requiresAuth: true,
      reteRicambiInternalAdminRoute: true,
    },
  },
  {
    path: "/rr-pass-reset",
    name: "rr-pass-reset",
    component: ReteRicambiPassReset,
    meta: {
      requiresAuth: true,
      superAdminRole: true,
    },
  },
  {
    path: "/moduli-rr/overview",
    name: "moduli-rr-overview",
    component: ModuliRrOverview,
    meta: {
      requiresAuth: true,
      moduliRrRole: true,
    },
  },
  {
    path: "/moduli-rr/orders",
    name: "moduli-rr-orders",
    component: ModuliRrOrders,
    meta: {
      requiresAuth: true,
      moduliRrRole: true,
    },
  },
  {
    path: "/moduli-rr/sales",
    name: "moduli-rr-sales",
    component: ModuliRrSales,
    meta: {
      requiresAuth: true,
      moduliRrRole: true,
    },
  },
];

// const routes = baseRoutes.concat(messagesRoutes, peopleRoutes);
const routes = baseRoutes;
const router = createRouter({
  history: createWebHistory(),
  routes,
});

function getToken() {
  if (localStorage.token) {
    return localStorage.token;
  }
  return false;
}

function getLanguage() {
  if (localStorage.language) {
    return localStorage.language;
  }
  return store.getters.language;
}

// Sends a post request to verify if the token stored in localstorage is valid.
// function verifyToken() {
//   const serverUri = config.getServerUri();

//   return new Promise(async (resolve) => {
//     try {
//       store.dispatch("startLoading");
//       const verificationResult = await axios.post(`${serverUri}/verify-token`, {
//         token: localStorage.token,
//       });
//       store.dispatch("verifyToken", verificationResult.data);
//       const institutionResult = await axios.get(
//         `${serverUri}/institution?id=${verificationResult.data.institution_id}`,
//         { headers: { Authorization: localStorage.token } },
//       );
//       const canLogin = institutionResult.data.institution[0].user_status;
//       if (!canLogin) {
//         localStorage.removeItem("exp");
//         localStorage.removeItem("token");
//         store.dispatch("logoutAction");
//         store.dispatch("finishLoading");
//         router.push({
//           path: "/auth",
//         });
//       }
//       const rrMember = institutionResult.data.institution[0].rr;
//       store.dispatch("setRrMember", rrMember);
//       const exportEbayLeko =
//         institutionResult.data.institution[0].export_ebay_leko;
//       store.dispatch("institutionExportEbayLekoAction", exportEbayLeko);
//       const exportGoogleLeko =
//         institutionResult.data.institution[0].export_google_merchant_leko;
//       store.dispatch("institutionExportGoogleLekoAction", exportGoogleLeko);
//       const { displayFeatures } =
//         institutionResult.data.institution[0].preferences;
//       store.dispatch("institutionDisplayFeaturesAction", displayFeatures);
//       store.dispatch("finishLoading");
//       const { hasUnpaidInvoices } = institutionResult.data.institution[0];
//       store.dispatch("setHasUnpaidInvoices", hasUnpaidInvoices);
//       resolve(verificationResult.status);
//     } catch (error) {
//       localStorage.removeItem("exp");
//       localStorage.removeItem("token");
//       store.dispatch("logoutAction");
//       store.dispatch("finishLoading");
//       router.push({
//         path: "/auth",
//       });
//     }
//   });
// }
async function verifyToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    store.dispatch("startLoading");

    // Verify the token
    const verificationResult = await axios.post(
      `${config.getServerUri()}/verify-token`,
      {
        token,
      },
    );

    // Get institution and user info
    const institutionResult = await axios.get(
      `${config.getServerUri()}/institution?id=${verificationResult.data.institution_id}`,
      { headers: { Authorization: token } },
    );

    const userInfo = institutionResult.data.institution[0];

    // Update store
    store.dispatch("verifyToken", verificationResult.data);
    store.dispatch("setRrMember", userInfo.rrMember);
    store.dispatch("setAziendaRR", userInfo.aziendaRR === true);
    store.dispatch("setInstitutionRr", userInfo.rr === true);
    store.dispatch("setRemainingPlates", userInfo.plates.remaining);
    store.dispatch(
      "institutionExportEbayLekoAction",
      userInfo.export_ebay_leko,
    );
    store.dispatch(
      "institutionExportGoogleLekoAction",
      userInfo.export_google_merchant_leko,
    );
    store.dispatch(
      "institutionDisplayFeaturesAction",
      userInfo.preferences.displayFeatures,
    );
    // Dismantling & Compliance: the institution switch AND the global switch
    // (Global Settings). The global one is only asked for when the institution's is on;
    // a failed read counts as off. Cosmetic only; the API checks both itself.
    let complianceEnabled = Boolean(
      userInfo.dismantlingCompliance &&
        userInfo.dismantlingCompliance.enabled === true,
    );
    if (complianceEnabled) {
      try {
        const globalResult = await axios.get(
          `${config.getServerUri()}/global-settings/dismantling-compliance`,
          { headers: { Authorization: token } },
        );
        complianceEnabled = globalResult.data.enabled === true;
      } catch (error) {
        complianceEnabled = false;
      }
    }
    store.dispatch("setComplianceEnabled", complianceEnabled);
    store.dispatch(
      "setCompliancePraEnabled",
      Boolean(
        userInfo.dismantlingCompliance &&
          userInfo.dismantlingCompliance.pra &&
          userInfo.dismantlingCompliance.pra.enabled === true,
      ),
    );
    store.dispatch(
      "setComplianceWorkshopEnabled",
      Boolean(
        userInfo.dismantlingCompliance &&
          userInfo.dismantlingCompliance.workshop &&
          userInfo.dismantlingCompliance.workshop.enabled === true,
      ),
    );
    store.dispatch(
      "setComplianceWasteEnabled",
      Boolean(
        userInfo.dismantlingCompliance &&
          userInfo.dismantlingCompliance.waste &&
          userInfo.dismantlingCompliance.waste.enabled === true,
      ),
    );
    store.dispatch("setHasUnpaidInvoices", userInfo.hasUnpaidInvoices);

    store.dispatch("finishLoading");

    // Return full user info
    return userInfo;
  } catch (error) {
    // Token invalid or API error → logout
    localStorage.removeItem("token");
    localStorage.removeItem("exp");
    store.dispatch("logoutAction");
    store.dispatch("finishLoading");
    return null;
  }
}

// router.beforeEach((to, from, next) => {
//   const language = getLanguage();
//   store.dispatch("languageAction", language);
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (to.matched.some((record) => record.meta.adminRole)) {
//       const token = getToken();
//       if (!token) {
//         router.push({
//           path: "/auth",
//         });
//       } else {
//         verifyToken().then((status) => {
//           if (status === 200) {
//             if (
//               store.getters.role === "User" ||
//               store.getters.role === "InstitutionManager"
//             ) {
//               router.push({
//                 path: "/home",
//               });
//             } else if (
//               store.getters.role === "LekoAdmin" ||
//               store.getters.role === "LekoEmployee" ||
//               store.getters.role === "InstitutionAdmin" ||
//               store.getters.role === "SuperAdmin"
//             ) {
//               next();
//             }
//           }
//         });
//       }
//     } else if (to.matched.some((record) => record.meta.employeeRole)) {
//       const token = getToken();
//       if (!token) {
//         router.push({
//           path: "/auth",
//         });
//       } else {
//         verifyToken().then((status) => {
//           if (status === 200) {
//             if (
//               store.getters.role === "User" ||
//               store.getters.role === "InstitutionManager" ||
//               store.getters.role === "InstitutionAdmin"
//             ) {
//               router.push({
//                 path: "/home",
//               });
//             } else if (
//               store.getters.role === "LekoAdmin" ||
//               store.getters.role === "LekoEmployee" ||
//               store.getters.role === "LekoBot" ||
//               store.getters.role === "SuperAdmin"
//             ) {
//               next();
//             }
//           }
//         });
//       }
//     } else if (to.matched.some((record) => record.meta.superAdminRole)) {
//       const token = getToken();
//       if (!token) {
//         router.push({
//           path: "/auth",
//         });
//       } else {
//         verifyToken().then((status) => {
//           if (status === 200) {
//             if (
//               store.getters.role === "User" ||
//               store.getters.role === "InstitutionManager" ||
//               store.getters.role === "InstitutionAdmin" ||
//               store.getters.role === "LekoAdmin" ||
//               store.getters.role === "LekoEmployee" ||
//               store.getters.role === "LekoBot"
//             ) {
//               router.push({
//                 path: "/home",
//               });
//             } else if (store.getters.role === "SuperAdmin") {
//               next();
//             }
//           }
//         });
//       }
//     } else {
//       const token = getToken();
//       if (!token) {
//         router.push({
//           path: "/auth",
//         });
//       } else {
//         verifyToken().then((status) => {
//           if (status === 200) {
//             next();
//           }
//         });
//       }
//     }
//   } else if (to.matched.some((record) => record.meta.authRoute)) {
//     const token = getToken();
//     if (!token) {
//       next();
//     } else {
//       verifyToken().then((status) => {
//         if (status === 200) {
//           router.push({
//             path: "/home",
//           });
//         }
//       });
//     }
//     //    if (to.matched.some(record => record.meta.authRoute)) {
//     //   next(); // skip token verification for login page
//     // } else {
//     //   next(); // keep normal flow for other routes
//     // }
//   } else {
//     next();
//   }
// });
router.beforeEach(async (to, from, next) => {
  const language = getLanguage();
  store.dispatch("languageAction", language);

  if (to.matched.some((record) => record.meta.public)) {
    return next();
  }

  // Routes that require auth
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = getToken();
    if (!token) return next({ path: "/auth" });

    // Call verifyToken() once per navigation
    const user = await verifyToken();

    if (!user || !user.user_status) {
      // User is disabled or token invalid
      localStorage.removeItem("token");
      localStorage.removeItem("exp");
      store.dispatch("logoutAction");
      store.dispatch("finishLoading");

      const fromProtectedRoute = from.matched.some(
        (record) => record.meta.requiresAuth,
      );
      const isBlockedAccount = user && !user.user_status;

      // Only surface the blocked alert when kicked out mid-session — not on a
      // fresh app open with a stale token (e.g. bookmarked /auth or cold start).
      if (fromProtectedRoute && isBlockedAccount) {
        localStorage.setItem(
          "authMessage",
          "Account blocked! Contact Administrator.",
        );
        return next({ path: "/auth", query: { blocked: "true" } });
      }

      localStorage.removeItem("authMessage");
      return next({ path: "/auth" });
    }

    const role = store.getters.role;

    // Admin routes
    if (to.matched.some((record) => record.meta.adminRole)) {
      if (
        ![
          "LekoAdmin",
          "LekoEmployee",
          "InstitutionAdmin",
          "SuperAdmin",
        ].includes(role)
      ) {
        return next({ path: "/home" });
      }
    }
    // Employee routes
    else if (to.matched.some((record) => record.meta.employeeRole)) {
      if (
        !["LekoAdmin", "LekoEmployee", "LekoBot", "SuperAdmin"].includes(role)
      ) {
        return next({ path: "/home" });
      }
    }
    // SuperAdmin routes
    else if (to.matched.some((record) => record.meta.superAdminRole)) {
      if (role !== "SuperAdmin") {
        return next({ path: "/home" });
      }
    }
    // ReteRicambi internal admin (email allowlist)
    else if (
      to.matched.some((record) => record.meta.reteRicambiInternalAdminRoute)
    ) {
      const email = store.getters.userEmail;
      if (!isReteRicambiInternalAdminEmail(email)) {
        return next({ path: "/home" });
      }
    }
    // RR members only (LekoAdmin / SuperAdmin can also access for support)
    else if (to.matched.some((record) => record.meta.requiresRrMember)) {
      const isRrMember = store.getters.rr_member === true;
      const isLekoStaff = ["LekoAdmin", "SuperAdmin"].includes(role);
      if (!isRrMember && !isLekoStaff) {
        return next({ path: "/home" });
      }
    }
    // Moduli RR: SuperAdmin, LekoAdmin, or InstitutionAdmin of aziendaRR institutions
    else if (to.matched.some((record) => record.meta.moduliRrRole)) {
      const isLekoStaff = ["LekoAdmin", "SuperAdmin"].includes(role);
      const isAziendaRrAdmin =
        role === "InstitutionAdmin" && store.getters.aziendaRR === true;
      if (!isLekoStaff && !isAziendaRrAdmin) {
        return next({ path: "/home" });
      }
    }
    // RR shop visibility: RR-member InstitutionAdmin or Leko staff
    else if (to.matched.some((record) => record.meta.rrDisplayRole)) {
      const isLekoStaff = ["LekoAdmin", "SuperAdmin"].includes(role);
      const isRrInstitutionAdmin =
        role === "InstitutionAdmin" && store.getters.rr_member === true;
      if (!isLekoStaff && !isRrInstitutionAdmin) {
        return next({ path: "/home" });
      }
    }
    else if (to.matched.some((record) => record.meta.allowedRoles)) {
      const allowedRecord = to.matched.find((record) =>
        Array.isArray(record.meta.allowedRoles),
      );
      const allowed = allowedRecord ? allowedRecord.meta.allowedRoles : [];
      if (!allowed.includes(role)) {
        return next({ path: "/home" });
      }
    }

    if (to.matched.some((record) => record.meta.requiresEbayExportLeko)) {
      if (
        role !== "SuperAdmin" &&
        !store.getters.institutionExportEbayLeko
      ) {
        return next({ path: "/home" });
      }
    }

    // Switch off or a role outside User / InstitutionManager / InstitutionAdmin.
    if (to.matched.some((record) => record.meta.requiresCompliance)) {
      if (!store.getters.complianceEnabled) {
        return next({ path: "/vehicle-entry" });
      }
    }

    // The workshop switch is off (or the compliance check above fails).
    if (to.matched.some((record) => record.meta.requiresWorkshop)) {
      if (!store.getters.workshopEnabled) {
        return next({ path: "/vehicle-entry" });
      }
    }

    // The waste switch is off (or the workshop check above fails).
    if (to.matched.some((record) => record.meta.requiresWaste)) {
      if (!store.getters.wasteEnabled) {
        return next({ path: "/vehicle-entry" });
      }
    }

    return next(); // Allow access
  }

  // Routes for login/register pages
  if (to.matched.some((record) => record.meta.authRoute)) {
    const token = getToken();
    const user = token ? await verifyToken() : null;

    if (user && user.user_status) {
      return next({ path: "/home" });
    }

    return next(); // Allow access to login/register
  }

  // Public routes
  next();
});

export default router;
